import { pstyle } from "../lib/pstyle.js";
import Hoverable from "../lib/Hoverable.jsx";

export default function Profile({ v }) {
  return (
    <div style={pstyle("padding:48px 44px 80px; max-width:820px; margin:0 auto; display:flex; flex-direction:column; gap:36px;")}>
      <div style={pstyle("display:flex; flex-direction:column; gap:10px;")}>
        <h1 style={pstyle("margin:0; font-size:32px; font-weight:600; letter-spacing:-0.025em;")}>Profil</h1>
        <p style={pstyle("margin:0; font-size:15px; color:oklch(0.5 0.015 60);")}>
          {v.profileSignedIn ? v.profileEmail : "Mode invité — connectez-vous pour synchroniser ces données entre appareils."}
        </p>
      </div>

      {v.profileSignedIn && (
        <div style={pstyle("display:flex; flex-direction:column; gap:10px;")}>
          <label htmlFor="profile-name" style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Nom affiché</label>
          <div style={pstyle("display:flex; gap:10px; max-width:360px;")}>
            <input
              id="profile-name"
              value={v.profileName}
              onChange={v.onProfileName}
              placeholder="Votre nom"
              style={pstyle("flex:1; border:1px solid oklch(0.9 0.01 85); border-radius:8px; padding:10px 12px; font-family:inherit; font-size:14px; color:oklch(0.22 0.012 60); outline:none;")}
            />
            <button
              type="button"
              onClick={v.saveProfileName}
              style={pstyle("border:none; border-radius:8px; padding:10px 18px; font-size:13.5px; font-family:inherit; cursor:pointer; background:oklch(0.24 0.012 60); color:oklch(0.98 0.005 85);")}
            >Enregistrer</button>
          </div>
        </div>
      )}

      <div style={pstyle("display:flex; flex-direction:column; gap:12px;")}>
        <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Favoris ({v.bookmarkCount})</div>
        {v.bookmarkCount === 0 && (
          <div style={pstyle("font-size:13.5px; color:oklch(0.55 0.015 60);")}>Aucun favori pour l'instant.</div>
        )}
        {v.bookmarkRows.map((b, i) => (
          <Hoverable
            key={i}
            onClick={b.onClick}
            style={pstyle("display:flex; align-items:baseline; gap:14px; padding:11px 4px; border-bottom:1px solid oklch(0.95 0.006 85); cursor:pointer;")}
            hoverStyle={{ background: "oklch(0.985 0.004 85)" }}
          >
            <span style={pstyle("font-size:14.5px; flex:1;")}>{b.title}</span>
            <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11px; color:oklch(0.55 0.015 60); border:1px solid oklch(0.93 0.008 85); border-radius:999px; padding:3px 10px;")}>{b.domain}</span>
          </Hoverable>
        ))}
      </div>

      <div style={pstyle("display:flex; flex-direction:column; gap:12px;")}>
        <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Notes ({v.noteCount})</div>
        {v.noteCount === 0 && (
          <div style={pstyle("font-size:13.5px; color:oklch(0.55 0.015 60);")}>Aucune note pour l'instant.</div>
        )}
        {v.noteRows.map((n, i) => (
          <Hoverable
            key={i}
            onClick={n.onClick}
            style={pstyle("display:flex; flex-direction:column; gap:4px; padding:11px 4px; border-bottom:1px solid oklch(0.95 0.006 85); cursor:pointer;")}
            hoverStyle={{ background: "oklch(0.985 0.004 85)" }}
          >
            <div style={pstyle("display:flex; align-items:baseline; gap:10px;")}>
              <span style={pstyle("font-size:14.5px;")}>{n.title}</span>
              <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:11px; color:oklch(0.55 0.015 60);")}>{n.wordCount} mots</span>
            </div>
            <span style={pstyle("font-size:13px; color:oklch(0.5 0.015 60); text-wrap:pretty;")}>{n.excerpt}</span>
          </Hoverable>
        ))}
      </div>
    </div>
  );
}
